import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { fetchAgreements, handleAgreement } from 'actions/Agreements';

import Agreement from 'components/Agreement';
import Loading from 'components/Loading';
import PanelMessage from 'components/panels/PanelMessage';

import { Subheader } from 'material-ui';

import forIn from 'lodash/forIn';
import map from 'lodash/map';
import isEmpty from 'lodash/isEmpty';
import { FormattedMessage } from 'react-intl';

const styles = {
  header: {
    fontSize: 20,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    maxWidth: 860,
  },
  container: {
    maxWidth: 720,
    width: '100%',
  },
  main: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    paddingBottom: 16,
  },
  empty: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 20,
    fontWeight: 500,
    opacity: 0.8,
  },
};

class Agreements extends React.Component {
  componentDidMount() {
    this.props.fetch();
  }

  render() {
    const {
      agreementsByID,
      agreementsLoading,
      hasError,
      agreementsError,
    } = this.props;

    if (agreementsLoading) {
      return <Loading />;
    }

    if (hasError) {
      return (
        <PanelMessage
          type="error"
          iconName="error"
          message={agreementsError.message || <FormattedMessage id="agreements.error" />}
        />
      );
    }

    const A = [
      <Subheader key="head" style={styles.header}>
        <FormattedMessage id="agreements.title" />
      </Subheader>,
    ];


    forIn(agreementsByID, ({ label, agreements, answers }, edID) => {
      const section = (
        <div style={styles.container} key={`${label}`}>
          <Subheader>
            {label}
          </Subheader>
          {isEmpty(agreements) &&
            <PanelMessage
              type="info"
              iconName="info"
              message={<FormattedMessage id="agreements.empty" />}
            />
          }
          {map(agreements, a => (
            <Agreement
              {...a}
              EmployeeDetailID={edID}
              handleAgreement={this.props.handleAgreement}
              answer={answers[a.HrAgreementID]}
              key={`${label}${a.HrAgreementID}`}
            />
          ))}
        </div>
      );
      A.push(section);
    });

    if (A.length === 1) {
      const empty = (
        <div style={styles.empty} key="empty">
          <FormattedMessage id="agreements.empty" />
        </div>
      );
      A.push(empty);
    }

    return <div style={styles.main}>{A}</div>;
  }
}

Agreements.propTypes = {
  agreementsByID: PropTypes.object.isRequired,
  fetch: PropTypes.func.isRequired,
  handleAgreement: PropTypes.func.isRequired,
  agreementsLoading: PropTypes.bool.isRequired,
  agreementsError: PropTypes.object,
  hasError: PropTypes.bool.isRequired,
};

export default connect(
  ({ AgreementsReducer }) => ({ ...AgreementsReducer }),
  dispatch => ({
    fetch: () => dispatch(fetchAgreements()),
    handleAgreement: (...args) => dispatch(handleAgreement(...args)),
  }),
)(Agreements);



// WEBPACK FOOTER //
// ./src/containers/Agreements.js